export const puctures: {
    artificalI: string;
    strategicHR: string;
    transitionalHR: string;
    logo: string;
} = {
    artificalI: require("./images/pagesImage/artificalI.webp"),
    strategicHR: require("./images/pagesImage/strategicHR.webp"),
    transitionalHR: require("./images/pagesImage/transitionalHR.webp"),
    logo: require("./images/logo/erhr_logo.webp"),
}
